// extracted by mini-css-extract-plugin
export default {"notice":"privacyNotice_notice__qhI0m","link":"privacyNotice_link__df-te"};